// export function validateLen (len = 20) {
//   return {
//     max: len,
//     message: '最大长度为' + len + '个字符',
//     trigger: 'change'
//   }
// }
// 验证是否为空-blur
export function notNullable (name) {
  let mes = ''
  if (name.length > 5) {
    mes = name
  } else {
    mes = '请输入' + name
  }
  return {
    required: true,
    message: mes,
    trigger: 'blur'
  }
}
// 验证是否为空-change
export function notNullableChange (mes) {
  return {
    required: true,
    message: mes,
    trigger: 'change'
  }
}
// 验证是否为空-change blur
export function notNullableAll (mes) {
  return {
    required: true,
    message: mes,
    trigger: ['change', 'blur']
  }
}
// 验证Excel文件
export function checkExcelFile () {
  return {
    validator: (rule, file, callback) => {
      if (file == '' || file == undefined || file == null) {//eslint-disable-line
        callback(new Error('请选择要上传的转化文件'))
      } else {
        const testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
        const extension = testmsg === 'xls'
        const extension2 = testmsg === 'xlsx'
        const isLt5M = file.size / 1024 / 1024 < 5
        if (!extension && !extension2) {
          callback(new Error('上传文件只能是 xls、xlsx格式!'))
        } else if (!isLt5M) {
          callback(new Error('文件大小不能超过 5MB!'))
        } else {
          callback()
        }
      }
    },
    required: true,
    trigger: 'change'
  }
}
export function checkAvatarImg () {
  return {
    validator: (rule, file, callback) => {
      if (file == '' || file == undefined || file == null) {//eslint-disable-line
        callback(new Error('请选择要上传的图片'))
      } else {
        if (file instanceof File) {
          // console.log(file)
          const testmsg = file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase()
          const extension = testmsg === 'png'
          const extension2 = (testmsg === 'jpeg' || testmsg === 'jpg')
          const isLt5M = file.size / 1024 / 1024 < 1
          if (!extension && !extension2) {
            callback(new Error('上传文件只能是 png、jpeg格式!'))
          } else if (!isLt5M) {
            callback(new Error('文件大小不能超过 1MB!'))
          } else {
            const img = new Image()
            img.src = URL.createObjectURL(file)
            let w = 0
            let h = 0
            img.onload = function() {
              w = img.width
              h = img.height
              img.onload = null
              console.log(w)
              console.log(h)
              if (w === 108 && h === 108) {
                callback()
              } else {
                callback(new Error('图片分辨率需为等比例'))
              }
            }
          }
        } else {
          if (file.startsWith('http')) {
            callback()
          } else {
            callback(new Error('请选择要上传的图片'))
          }
        }
      }
    },
    required: true,
    trigger: 'change'
  }
}
export function checkTxtFile () {
  return {
    validator: (rule, file, callback) => {
      if (file == '' || file == undefined || file == null) {//eslint-disable-line
        callback(new Error('请选择要上传的文件'))
      } else {
        const testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
        const extension = testmsg === 'txt'
        const isLt50M = file.size / 1024 / 1024 < 50
        if (!extension) {
          callback(new Error('上传文件只能是 txt格式!'))
        } else if (!isLt50M) {
          callback(new Error('文件大小不能超过 50MB!'))
        } else {
          callback()
        }
      }
    },
    required: true,
    trigger: 'change'
  }
}
// 验证手机号格式
export function telFormat () {
  return {
    validator: (rule, value, callback) => {
      const telReg = /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/
      if (value == '' || value == undefined || value == null) {//eslint-disable-line
        callback()
      } else {
        if (!telReg.test(value)) {
          callback(new Error('手机号格式不正确'))
        } else {
          callback()
        }
      }
    },
    trigger: 'blur'
  }
}
// 验证短信验证码格式
export function SMSFormat () {
  return {
    validator: (rule, value, callback) => {
      const SMSReg = /^\d{6}$/
      if (value == '' || value == undefined || value == null) {//eslint-disable-line
        callback()
      } else {
        if (!SMSReg.test(value)) {
          callback(new Error('验证码格式不正确'))
        } else {
          callback()
        }
      }
    },
    trigger: 'blur'
  }
}

// 验证密码格式
export function passwordFormat () {
  return {
    validator: (rule, value, callback) => {
      const passwordReg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/
      if (value == '' || value == undefined || value == null) {//eslint-disable-line
        callback()
      } else {
        if (!passwordReg.test(value)) {
          callback(new Error('密码格式不正确请重新输入'))
        } else {
          callback()
        }
      }
    },
    trigger: 'blur'
  }
}

// 验证日期格式
export function dateValidation (mes) {
  return {
    type: 'array',
    required: true,
    message: mes,
    trigger: 'blur'
  }
}

// 验证电话格式
export function phoneFormat (name) {
  return {
    validator: (rule, value, callback) => {
      const telReg = /^[0-9-()（）]{7,18}$/
      if (value == '' || value == undefined || value == null) {//eslint-disable-line
        callback()
      } else {
        if (!telReg.test(value)) {
          callback(new Error(name + '格式不正确'))
        } else {
          callback()
        }
      }
    },
    trigger: 'blur'
  }
}

// 验证企业邮箱
export function emailFormat (name) {
  return {
    validator: (rule, value, callback) => {
      const emailReg = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
      if (value == '' || value == undefined || value == null) {//eslint-disable-line
        callback()
      } else {
        if (!emailReg.test(value)) {
          callback(new Error(name + '格式不正确'))
        } else {
          callback()
        }
      }
    },
    trigger: 'blur'
  }
}

// 验证企业邮箱
export function packageNameFormat (name) {
  return {
    validator: (rule, value, callback) => {
      const packageNameReg = /^([a-zA-Z_][a-zA-Z0-9_]*)+([.][a-zA-Z_][a-zA-Z0-9_]*)+$/
      if (value == '' || value == undefined || value == null) {//eslint-disable-line
        callback()
      } else {
        if (!packageNameReg.test(value)) {
          callback(new Error(name + '格式不正确'))
        } else {
          callback()
        }
      }
    },
    trigger: 'blur'
  }
}

// code
export function codeFormat (name) {
  return {
    validator: (rule, value, callback) => {
      if (value == '' || value == undefined || value == null) {//eslint-disable-line
        callback()
      } else {
        if (value.indexOf('{code}') === -1) {
          callback(new Error(name + '中必须包含{code}'))
        } else {
          callback()
        }
      }
    },
    trigger: 'blur'
  }
}

// 获取字节数
export function getChars (str) {
  var i = 0
  var c = 0.0
  var unicode = 0
  var len = 0
  if (str === '' || str == null) {
    return 0
  }

  len = str.length
  for (i = 0; i < len; i++) {
    unicode = str.charCodeAt(i)
    if (unicode < 127) { // 判断是单字符还是双字符
      c += 1
    } else { // chinese
      c += 2
    }
  }
  return c
}

// 字符不小于num
export function sizeMin (name, num) {
  return {
    validator: (rule, value, callback) => {
      if (value == '' || value == undefined || value == null) {//eslint-disable-line
        callback()
      } else {
        if (getChars(value) < (num * 2)) {
          callback(new Error(name + '不能小于' + num + '个字符'))
        } else {
          callback()
        }
      }
    },
    trigger: 'blur'
  }
}
export function sizeMinMax (name, minNum, MaxNum) {
  return {
    validator: (rule, value, callback) => {
      if (value == '' || value == undefined || value == null) {//eslint-disable-line
        callback()
      } else {
        if (getChars(value) < minNum) {
          callback(new Error(name))
        } else if ((getChars(value) > MaxNum)) {
          callback(new Error(name))
        } else {
          callback()
        }
      }
    },
    trigger: 'blur'
  }
}

// 字符不大于num
export function sizeMax (name, num, mes) {
  return {
    validator: (rule, value, callback) => {
      if (value == '' || value == undefined || value == null) {//eslint-disable-line
        callback()
      } else {
        // console.log(name)
        if (name === 'adGroupName') {
          // console.log(getChars(value.replace('{渠道名称}', '')))
          if (getChars(value.replace('{渠道名称}', '')) > num) {
            callback(new Error(mes))
          } else {
            callback()
          }
        } else {
          if (getChars(value) > (num * 2)) {
            callback(new Error(name + '最多为' + num + '字符'))
          } else {
            callback()
          }
        }
      }
    },
    trigger: 'blur'
  }
}
// 字数区间限制
export function fontSizeInterval(name, min, max, type) {
  return {
    validator: (rule, value, callback) => {
      if (type === 0 && (!value || value.length === 0)) {
        return callback()
      }
      if (getChars(value) < (min * 2) || getChars(value) > (max * 2) || value === '' || value === undefined || value == null) {
        callback(new Error(name + min + '-' + max + '个字，请正确输入'))
      } else {
        callback()
      }
    },
    trigger: ['change', 'blur']
  }
}

// 不支持输入特殊字符
export function noSpecialFont() {
  return {
    validator: (rule, value, callback) => {
      // eslint-disable-next-line no-useless-escape
      // const reg = /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、]/im
      const reg = /[{}]/
      if (reg.test(value)) {
        callback(new Error('不支持输入特殊字符'))
      } else {
        callback()
      }
    },
    trigger: ['change', 'blur']
  }
}

// 字符串的长度
export function strMax (text, num) {
  return {
    validator: (rule, value, callback) => {
      if (value == '' || value == undefined || value == null) {//eslint-disable-line
        callback()
      } else {
        if (value.length > num) {
          callback(new Error(text))
        } else {
          callback()
        }
      }
    },
    trigger: 'blur'
  }
}

// 数字不大于num
export function numMax (text, num) {
  return {
    validator: (rule, value, callback) => {
      if (value == '' || value == undefined || value == null) {//eslint-disable-line
        callback()
      } else {
        if (value > num) {
          callback(new Error(text))
        } else {
          callback()
        }
      }
    },
    trigger: 'blur'
  }
}
// 数字不小于num
export function numMin (text, num) {
  return {
    validator: (rule, value, callback) => {
      if (value == '' || value == undefined || value == null) {//eslint-disable-line
        callback()
      } else {
        if (value < num) {
          callback(new Error(text))
        } else {
          callback()
        }
      }
    },
    trigger: 'blur'
  }
}
// 预算验证
export function dailyBudget () {
  return {
    validator: (rule, value, callback) => {
      if (value == '' || value == undefined || value == null) {//eslint-disable-line
        callback()
      } else {
        if (value > 9999999.99 || value < 300) {
          callback(new Error('预算不少于300.00元，不超过9,999,999.99元，请正确输入'))
        } else {
          callback()
        }
      }
    },
    trigger: 'blur'
  }
}

// ip格式
export function IPFormat (name) {
  return {
    validator: (rule, value, callback) => {
      // const ipReg = /^(((2(5[0-5]|[0-4]\d))|[0-1]?\d{1,2})(\.((2(5[0-5]|[0-4]\d))|[0-1]?\d{1,2})){3})+(,(((2(5[0-5]|[0-4]\d))|[0-1]?\d{1,2})(\.((2(5[0-5]|[0-4]\d))|[0-1]?\d{1,2})){3}))*$/
      // const ipReg = /^(?:(?:^|(?<!^),)(?:[0-9]|[1-9]\d|1\d{2}|2[0-4]\d|25[0-5])(?:\.(?:[0-9]|[1-9]\d|1\d{2}|2[0-4]\d|25[0-5])){3})+$/
      const ipReg = /^(?:(?:[0-9]|[1-9]\d|1\d{2}|2[0-4]\d|25[0-5])(?:\.(?:[0-9]|[1-9]\d|1\d{2}|2[0-4]\d|25[0-5])){3}(?:,(?!$)|$))+$/
      if (value == '' || value == undefined || value == null) {//eslint-disable-line
        callback()
      } else {
        if (!ipReg.test(value)) {
          callback(new Error(name + '格式不正确。例:指定IP地址：192.168.0.1,192.168.0.2   IP之间用英文“,”隔开'))
        } else {
          callback()
        }
      }
    },
    trigger: 'change'
  }
}

// 出价验证
export function agentBid (min, max, str) {
  return {
    validator: (rule, value, callback) => {
      if (value === '' || value === undefined || value === null) {//eslint-disable-line
        callback()
      } else {
        value += ''
        if (value.indexOf('.') !== -1 && value.split('.').length > 2) {
          callback(new Error('请输入正确格式的金额')) // 防止输入多个小数点
        } else if (value > max || value < min) {
          if (!str) {
            callback(new Error('出价范围为' + min + '-' + max + '元'))
          } else {
            callback(new Error(str))
          }
        } else if (value.indexOf('.') !== -1 && value.split('.')[1].length > 2) {
          callback(new Error('小数点后最多两位数')) // 小数点后两位
        } else {
          callback()
        }
      }
    },
    trigger: ['change', 'blur']
  }
}

// 整数值验证 —— 提高/降低出价
export function integerValue (min, max, name) {
  return {
    validator: (rule, value, callback) => {
      if (value === '' || value === undefined || value === null) {//eslint-disable-line
        callback()
      } else {
        if (value <= min) {
          if (name) {
            callback(new Error('输入' + name + '不能小于' + min))
          } else {
            callback(new Error('请输入大于' + min + '的整数值'))
          }
        } else if (value > max) {
          if (name) {
            callback(new Error('输入' + name + '不能大于' + max))
          } else {
            callback(new Error('请输入小于' + max + '的整数值'))
          }
        } else {
          callback()
        }
      }
    },
    trigger: 'blur'
  }
}

// 验证url
export function checkUrl() {
  return {
    validator: (rule, value, callback) => {
      if (value !== '') {
        let reg = /[a-zA-z0-9]+:\/\/[^\s]*/
        if (!reg.test(value)) {
          console.log('请输入正确的链接')
          callback(new Error('请输入正确的链接'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    },
    required: true,
    trigger: ['change', 'blur']
  }
}

// 验证直达链接
export function checkOpenUrl() {
  return {
    validator: (rule, value, callback) => {
      if (value !== '') {
        let reg = /[a-zA-z0-9]+:\/\/[^\s]*/
        // let reg = /^(tbopen|alipays|openapp\.jdmobile|suning|vipshop|pddopen|mogujie|wireless1688):\/\/([\w-.])+[\w-]+(\/[\w-./?%&=:]*)?$/
        if (!reg.test(value)) {
          callback(new Error('直达链接格式不正确'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    },
    required: true,
    trigger: ['change', 'blur']
  }
}



// WEBPACK FOOTER //
// ./src/components/form/formValidation.js